import { gql } from '@apollo/client'

import { SHOP_FRAGMENT } from '../fragments'

export const GET_CURRENT_SHOP = gql`
  query CurrentShop {
    currentShop {
      ...Shop
    }
  }
  ${SHOP_FRAGMENT}
`

export const GET_CURRENT_SHOP_PAYMENT_SETTINGS = gql`
  query CurrentShopPaymentSettings {
    currentShop {
      id
      isSpreedlyPaymentsAvailable
      isSquarePaymentsAvailable
    }
  }
`

export const GET_CURRENT_SHOP_TWO_FACTOR_AUTH = gql`
  query CurrentShopTwoFactorAuth {
    currentShop {
      id
      twoFactorAuth
    }
  }
`
